import http from "./http";

/* =========================
   ADD NON INVENTORY ITEM
========================= */
export const addNonInventoryItem = async (payload) => {
  const res = await http.post(
    "non_inventory_items?action=add",
    {
      name: payload.name,
      description: payload.description,
    }
  );
  return res.data;
};

/* =========================
   UPDATE NON INVENTORY ITEM
========================= */
export const updateNonInventoryItem = async (id, payload) => {
  const res = await http.post(
    "non_inventory_items?action=update",
    {
      id,
      name: payload.name,
      description: payload.description,
    }
  );
  return res.data;
};

/* =========================
   GET ALL
========================= */
export const getNonInventoryItems = async () => {
  const res = await http.post(
    "non_inventory_items?action=get_all",
    {}
  );
  return res.data;
};

/* =========================
   ✅ GET SINGLE (EDIT)
   EXACT MATCH WITH POSTMAN
   GET /non_inventory_items?action=get&id=ID
========================= */
export const getNonInventoryItemById = async (id) => {
  const res = await http.get(
    `non_inventory_items?action=get&id=${id}`
  );
  return res.data;
};

/* =========================
   DELETE
========================= */
export const deleteNonInventoryItem = async (id) => {
  const res = await http.post(
    "non_inventory_items?action=delete",
    { id }
  );
  return res.data;
};
